import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DatePicker } from 'antd';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import moment from 'moment'

import {
  Container,
  Grid, IconButton,
  MenuItem,
  Paper,
  Table, TableBody, TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField
} from "@material-ui/core";
import GetAppIcon from '@material-ui/icons/GetApp';
import { GetArchives, GetArchivesFile } from './archiveAction';
import Month from './monthList.json'
import OverLoader from '../../components/common/loader';

const dateFormat = 'YYYY';

class Archive extends Component {


  constructor(props) {
    super(props);
    this.state = {
      yearField: new Date().getFullYear(),
      monthField: new Date().getMonth() + 1,
      type: "",


    }
  }

  componentDidMount = () => {
    const { yearField, monthField, type } = this.state
    this.props.GetArchives(yearField, monthField, type)
  }

  getArchiveList = () => {

    const { yearField, monthField, type } = this.state
    this.props.GetArchives(yearField, monthField, type)

  }

  yearFieldHandleChange = (e) => {
    if (e !== null) {
      let date = moment(e._d).format("YYYY");
      this.setState({ yearField: date }, () => this.getArchiveList())
    } else {
      this.setState({ yearField: '' })
    }
  }

  isEven = (n) => {
    return n % 2 === 0;
  }

  render() {
    const { yearField, monthField, type } = this.state
    const { isloading, archive_data } = this.props
    return (
      <React.Fragment>
        {isloading && <OverLoader />}
        <Container maxWidth="md">
          <Grid container spacing={3} className="mainBlock">
            <Grid item xs={12}>
              <div className="rightBlock">
                <Grid container spacing={1} justify="center" className="fullWidth">
                  <Grid container item xs={7} spacing={1} style={{ height: '115px' }}>
                    <Grid item xs={3} style={{ lineHeight: '2.5' }}>
                      Bericht
                      </Grid>
                    <Grid item xs={8}>
                      <TextField
                        value={type}
                        select
                        variant="outlined"
                        className="select-box"
                        size="small"
                        fullWidth
                        onChange={(e) => {
                          this.setState({ type: e.target.value }, () => this.getArchiveList())
                        }}
                      >
                        <MenuItem value="be">Beraterplan</MenuItem>
                        <MenuItem value="Akquiseliste">Akquiseliste</MenuItem>
                        <MenuItem value="6 Monatsplan">6-Monatsplan</MenuItem>

                      </TextField>
                    </Grid>
                    <Grid item xs={3} style={{ lineHeight: '2.5' }}>
                      Monat
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        select
                        variant="outlined"
                        className="select-box"
                        size="small"
                        value={monthField}
                        fullWidth
                        onChange={(e) => this.setState({ monthField: e.target.value }, () => this.getArchiveList())}
                      >
                        {Month.map(item => {
                          return <MenuItem key={item.value} value={item.value}>{item.name}</MenuItem>

                        })}
                      </TextField>
                    </Grid>
                    <Grid item xs={4}>
                      <DatePicker
                        value={yearField === "" ? '' : moment(yearField, dateFormat)}
                        format={dateFormat}
                        allowClear={false}
                        bordered={false}
                        onChange={(e) => {
                          this.yearFieldHandleChange(e)
                        }}
                        picker="year" />
                    </Grid>
                  </Grid>
                  <Grid container item xs={11} spacing={1}
                    className={'fullWidth SearchResultsTableBorders'}>
                    <TableContainer component={Paper}>
                      <Table size="small" aria-label="dense table">
                        <TableHead>
                          <TableRow>
                            <TableCell>&nbsp;</TableCell>
                            <TableCell align="left">Bericht</TableCell>
                            <TableCell align="center">Datum</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {archive_data &&
                            archive_data.map((list, index) =>
                              <TableRow className={this.isEven(index) ? 'grey_row' : ""}>
                                <TableCell style={{ width: '10px' }}>
                                  <IconButton>
                                    <GetAppIcon onClick={() => this.props.GetArchivesFile(list.id, list.name, list.created_at)} />
                                  </IconButton>
                                </TableCell>
                                <TableCell align="left">{list.name}</TableCell>
                                <TableCell align="center">{moment(list.created_at).utc().format("DD.MM.YYYY")}</TableCell>
                              </TableRow>
                            )
                          }
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
        </Container>
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ ArchiveReducer }) => {
  return {
    isloading: ArchiveReducer.loading,
    archive_data: ArchiveReducer.archive_data,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    // dispatching actions
    GetArchives: (year, month, userId) => dispatch(GetArchives(year, month, userId)),
    GetArchivesFile: (id, name, created_date) => dispatch(GetArchivesFile(id, name, created_date)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Archive);